import WebApiService from "@/services/webapi.service.js";
import Esito from "@/models/esito.model.js";

const state = {
    esiti: {
        esitiOperazioni: null
    }
}

const getters = {

    getEsitiOperazioni: (state) => {
        return state.esiti.esitiOperazioni;
    },
    getDescrizioneEsito: (state) => (codice) => {       
        if(!state.esiti && !state.esiti.esitiOperazioni){
            return "";
        }

        let esito = state.esiti.esitiOperazioni.find(item => {return item.Codice === codice});
        if(!esito){
            return "";
        }
        return esito.Descrizione;
    }
}

const mutations = {

    setEsitiOperazioni: (state, esitiOperazioni) => {
        state.esiti.esitiOperazioni = esitiOperazioni;      
    }
}

const actions = {

    getEsitiOperazioni: ({commit}, data) => {                                                                                                              
        return WebApiService.get('interventi/GetEsitiOperazione', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setEsitiOperazioni", data.Data.map(
                        o => { return Object.assign(new Esito(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}